import React from 'react'
import {
  AiOutlineDoubleLeft,
  AiOutlineDoubleRight,
  AiOutlineLeft,
  AiOutlineRight
} from 'react-icons/ai'

import { PaginationProps } from './types.ts'

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  setCurrentPage,
  disabled = false
}) => {
  if (totalPages <= 1) return null

  const pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1)

  const baseBtnClass =
    'p-2 min-w-10 h-10 border rounded transition-colors disabled:opacity-50 disabled:hover:bg-transparent hover:bg-gray-100 dark:hover:bg-gray-700 dark:border-gray-600 dark:text-gray-300'

  const activeBtnClass =
    'bg-blue-500 text-white border-blue-500 dark:bg-blue-600 dark:border-blue-600 active-no-hover'

  return (
    <nav className="flex gap-2 justify-center items-center flex-wrap">
      <button
        onClick={() => setCurrentPage(1)}
        disabled={currentPage === 1 || disabled}
        className={`${baseBtnClass}`}
      >
        <AiOutlineDoubleLeft className="w-5 h-5" />
      </button>

      <button
        onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1 || disabled}
        className={`${baseBtnClass}`}
      >
        <AiOutlineLeft className="w-5 h-5" />
      </button>

      <div className="flex gap-1 items-center">
        {totalPages <= 7
          ? pageNumbers.map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                disabled={disabled}
                className={`${baseBtnClass} ${
                  page === currentPage
                    ? `${activeBtnClass} pointer-events-none`
                    : ''
                }`}
              >
                {page}
              </button>
            ))
          : (() => {
              const buttons = []

              // First page
              buttons.push(
                <button
                  key={1}
                  onClick={() => setCurrentPage(1)}
                  disabled={disabled}
                  className={`${baseBtnClass} ${
                    currentPage === 1
                      ? `${activeBtnClass} pointer-events-none`
                      : ''
                  }`}
                >
                  1
                </button>
              )

              if (currentPage > 3) {
                buttons.push(
                  <span key="start-ellipsis" className="p-2 dark:text-gray-300">
                    ...
                  </span>
                )
              }

              for (
                let i = Math.max(2, currentPage - 2);
                i <= Math.min(totalPages - 1, currentPage + 2);
                i++
              ) {
                buttons.push(
                  <button
                    key={i}
                    onClick={() => setCurrentPage(i)}
                    disabled={disabled}
                    className={`${baseBtnClass} ${
                      currentPage === i
                        ? `${activeBtnClass} pointer-events-none`
                        : ''
                    }`}
                  >
                    {i}
                  </button>
                )
              }

              if (currentPage < totalPages - 2) {
                buttons.push(
                  <span key="end-ellipsis" className="p-2 dark:text-gray-300">
                    ...
                  </span>
                )
              }

              // Last page
              buttons.push(
                <button
                  key={totalPages}
                  onClick={() => setCurrentPage(totalPages)}
                  disabled={disabled}
                  className={`${baseBtnClass} ${
                    currentPage === totalPages
                      ? `${activeBtnClass} pointer-events-none`
                      : ''
                  }`}
                >
                  {totalPages}
                </button>
              )

              return buttons
            })()}
      </div>

      <button
        onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage === totalPages || disabled}
        className={`${baseBtnClass}`}
      >
        <AiOutlineRight className="w-5 h-5" />
      </button>

      <button
        onClick={() => setCurrentPage(totalPages)}
        disabled={currentPage === totalPages || disabled}
        className={`${baseBtnClass}`}
      >
        <AiOutlineDoubleRight className="w-5 h-5" />
      </button>

      <span className="w-full text-center mx-2 text-sm text-gray-600 dark:text-gray-400">
        Strona{' '}
        <select
          className="border rounded px-1 py-0.5 mt-3 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-300"
          value={currentPage}
          onChange={(e) => setCurrentPage(Number(e.target.value))}
          disabled={disabled}
        >
          {pageNumbers.map((page) => (
            <option value={page} key={page}>
              {page}
            </option>
          ))}
        </select>{' '}
        z {totalPages}
      </span>
    </nav>
  )
}
